export default __webpack_public_path__ + "images/G3.e36f194.png";